var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "drag-n-drop",
        on: {
          dragover: function($event) {
            $event.preventDefault()
          },
          drop: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", {
          staticClass: "drag-n-drop-field",
          on: { drop: _vm.dragFile }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "drag-n-drop-inner" }, [
          _c("div", { ref: "swiper", staticClass: "swiper" }, [_vm._m(0)])
        ]),
        _vm._v(" "),
        _c("input", {
          ref: "uploadFile",
          attrs: {
            id: "uploadFile",
            type: "file",
            accept:
              "image/gif, image/png, image/jpeg, image/svg+xml, video/mp4",
            multiple: ""
          },
          on: { change: _vm.uploadFile }
        }),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "add-image-button", on: { click: _vm.focusInput } },
          [
            _vm.isMobile
              ? [_vm._v("Add Files to Create")]
              : [_vm._v("Choose Files from computer")]
          ],
          2
        ),
        _vm._v(" "),
        _c("p", { staticClass: "validation-hint" }, [
          _vm._v(
            "\n      Min res. 200x200px | Max file size 50MB | Max 30 sec. long | File\n      formats PNG, GIF, JPEG, SVG, MP4\n    "
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-wrapper" }, [
      _c("div", { staticClass: "swiper-slide" }, [
        _c("img", {
          attrs: {
            src: require("../../../../../public/img/slider/slide-1.svg"),
            width: "78",
            height: "90",
            alt: "Mint an NFT"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slide-text mint-text" }, [
          _vm._v("Mint an NFT")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("img", {
          attrs: {
            src: require("../../../../../public/img/slider/slide-2.png"),
            width: "129",
            height: "120",
            alt: "Make a Sticker"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slide-text sticker-text" }, [
          _vm._v("Make a Sticker")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "gif" }, [
          _c("img", {
            attrs: {
              src: require("../../../../../public/img/slider/slide-3.gif"),
              width: "159",
              height: "145",
              alt: "Make a Gif"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "slide-text gif-text" }, [
          _vm._v("Make a Gif")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }